import type { BottegaBlock } from '@velasca/types'
import { $bottega_blocks, $page_bottega } from '@velasca/utils/globals'
import { useBottega } from '../../BottegaProvider'
import Bottega from '../Bottega'
import type { BottegaLabels } from '../Bottega/Bottega'

const BottegaList = () => {
  const bottega = useBottega()

  if (!bottega) {
    return null
  }

  const { currentCityGroup } = bottega

  return (
    <div className="bottega-list col-md-10 col-md-offset-1">
      {$bottega_blocks.map((bottegaBlock: BottegaBlock) =>
        currentCityGroup === '' ||
        (bottegaBlock.city_group &&
          currentCityGroup === bottegaBlock.city_group) ? (
          <Bottega
            key={bottegaBlock.id}
            labels={$page_bottega as unknown as BottegaLabels}
            bottega={bottegaBlock}
          />
        ) : null,
      )}
    </div>
  )
}

export default BottegaList
